import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Tooltip, Button, Icon } from 'antd';
import { serviceFields } from '../../const/simbix';
import PropertyLabel from '../owl/ProperyLabel';
import URILink from '../widgets/URILink';

/** Отображение списка значений для карточки FOAF
 * Формируется таблица, содержащая столбец с названием поля и столбец со значением поля
 * Для отображения поля используются специальные компоненты. Виды компонент описаны в widgets.
 * Получает список 
 */
const sortedStartPart = ['rdf_about', 'dcterms_language']
const sortedFinishPart = ['owl_versionInfo', 'csi_prefix']
const exclude = ['NName', "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"];

//Фильтрует полученные свойства для отображения. Исключает служебные свойства, свойства с пустыми значениями
//predicates содержит все предикаты, имеющие значения
const filterForShow = (predicates, values) => {
    //Исключаем служебные элементы
    const first = predicates.filter(key => !serviceFields.includes(key)); 
    //Исключаем свойства, которые не должны показываться
    const properties = first.filter(key => !exclude.includes(key));
    //Формируем последовательность свойств для отображения
    //console.log(properties)
    return properties.sort ((a, b) => {
            //console.log("0", a, b);
            //Начало списка свойств
            let indexA = sortedStartPart.indexOf(a);
            let indexB = sortedStartPart.indexOf(b);
            //console.log("1", indexA, indexB);
            if (indexA>-1){
                if (indexB>-1) return indexA-indexB;
                return -1;
            };
            if (indexB>-1) return 1;
            //конец списка свойств
            indexA = sortedFinishPart.indexOf(a);
            indexB = sortedFinishPart.indexOf(b);
            //console.log("2", indexA, indexB);
            if (indexA>-1){
                if (indexB < 0) return 1;
                return indexA-indexB;
            };
            if (indexB>-1) return 1;
            return 0;
        });
}


/** Для отображения значения поля. Для отображения необходимо указать:
 * 1. Предикат, содержащий данные
 * 2. Массив данных из которых их брать
 * 3. Язык
 * 4. Фабрика, которая возвращает компоненту для создания
 */
const FieldViewProxy = ({predicat, values, lang, factory, action}) =>{
    const Component = factory.ui.getUIComponent(predicat);
    return (
        <div className="csi_value_div">
          <Component lang={lang} uri={predicat} values={values} factory={factory} action={action}/>
        </div>
    )
}

/** Базовая компонента отображения детальной информции о свойстве  */
class DetailLinkCardBase extends React.Component {
    state = {
        selected: undefined,    //Свойство (predicat), которое редактируется, удаляется или для него осуществляется перерво
        operation: "view",      //Текущая операция. Может быть view, edit, translate, delete
    }

    render(){
        //console.log(this); 
        const {predicates, values, lang, factory, iri} = this.props;
        const properties = filterForShow(predicates, values);
        const FieldProxy = FieldViewProxy;
        return (
            <span>
            <Row className="assetCardTable_tr"> 
              <Col span={10} className="assetCardTable_td"><div className="csi_field_div">URI</div></Col>
              <Col span={14} className="assetCardTable_td">
                <div className="csi_value_div">
                  <URILink uri={iri} factory={factory} operation={"view"}/>
                </div>
              </Col>
            </Row>
                {properties.map((prop, i) => 
          <Row key={i} className="assetCardTable_tr"> 
					<Col span={10} className="assetCardTable_td">
						<PropertyLabel iri={prop} factory={factory} />
					</Col>
					<Col span={14} className="assetCardTable_td" style={{display: "block"}}>
						<FieldProxy 
							factory={factory} lang={lang} predicat={prop} values={values}
							{...this.state} 
							action={(e, type, predicat)=> this.onAction(e, type, predicat)}/>
					</Col>
				</Row>
					)}
      </span>
        )
        }
}

export const DetailLinkCard = connect(
  (state, props) => {
    //Значения в store redux
    const {vasset, vset } = state;
    const {lang, triplet} = props;
    //Если есть детальная информация отдельно
    const detail = (vasset.details[triplet.object.value])?vasset.details[triplet.object.value].values: null;
    //Если детальная информация внутри триплетов ассета
    const items = vasset.values.filter(item => (item.object.value == triplet.object.value)&&(item.predicat.value == triplet.predicat.value));
    const values = (items && Array.isArray(items) && items.length>0)? items[0].values: detail;
    const predicates = (values && Array.isArray(values))?[...new Set(values.map(item => item.predicat.value))]:[];
    return {
      lang: (lang)?lang: vset.lang,      
      iri: triplet.object.value,
      predicates,
      values,
    };
  }
)(DetailLinkCardBase);

export const DetailLinkScheme = connect(
  (state, props) => {
    //Значения в store redux
    const {scheme, vset } = state;
    const {lang, triplet} = props;
    //Если есть детальная информация отдельно
    const detail = (scheme.details[triplet.object.value])?scheme.details[triplet.object.value].values: null;
    const values = detail;
    const predicates = (values && Array.isArray(values))?[...new Set(values.map(item => item.predicat.value))]:[];
    return {
      lang: (lang)?lang: vset.lang,      
      iri: triplet.object.value,
      predicates,
      values,
    };
  }
)(DetailLinkCardBase);